export default __webpack_public_path__ + "static/media/ASPA_PARTNER_FOCUS_8.366a2333.png";